import React, {PureComponent} from "react"
import {Deal} from "@irati/types"
import getLimits from "@irati/deals/utils/deal/limits"
import withBasket, {WithBasket} from "@irati/checkout/utils/basket/withBasket"
import {hitLimits} from "@irati/checkout/utils/deal/limits"
import getCurrencyForDeal from "@irati/deals/helpers/deals/currency"
import {MaxAmountReached, MaxItemsReached, MaxProductsReached, UnderMinAmount} from "./Limits"
import ProductTypes from "../../../../constants/productTypes"

interface Props extends WithBasket {
  deal: Deal,
  productType?: ProductTypes
}

interface State {
  reachedMinPrice: boolean,
  reachedMaxPrice: boolean,
  reachedMaxProducts: boolean,
  reachedMaxItems: boolean,
  minPrice: number,
  maxPrice: number,
  maxItems: number,
  currency: string
}

class LimitWrapper extends PureComponent<Props, State> {
  static getDerivedStateFromProps(props: Props) {
    const currency = getCurrencyForDeal(props.deal)
    const {reachedMinPrice, reachedMaxPrice, reachedMaxProducts, reachedMaxItems} = hitLimits(props.deal)
    const {minPrice, maxPrice, numItems: maxItems} = getLimits(props.deal)
    return {currency, minPrice, maxPrice, maxItems, reachedMinPrice, reachedMaxPrice, reachedMaxProducts, reachedMaxItems}
  }

  basketSub?: ZenObservable.Subscription

  state: State = {
    reachedMinPrice: false,
    reachedMaxPrice: false,
    reachedMaxProducts: false,
    reachedMaxItems: false,
    minPrice: 0,
    maxPrice: 0,
    maxItems: 0,
    currency: "GBP"
  }

  render() {
    const {reachedMinPrice, reachedMaxPrice, reachedMaxProducts, reachedMaxItems, minPrice, maxPrice, maxItems, currency} = this.state
    const {productType} = this.props

    const isCinema = productType === ProductTypes.CINEMA
    const isSingleProduct = productType === ProductTypes.SINGLE_PRODUCT
    const showWarning = !isCinema && !isSingleProduct

    return (
      <div>
        {!isSingleProduct && reachedMaxItems && <MaxItemsReached maxItems={maxItems} />}
        {showWarning && reachedMaxPrice && <MaxAmountReached maxPrice={maxPrice} currency={currency} />}
        {showWarning && !reachedMinPrice && <UnderMinAmount minPrice={minPrice} currency={currency} />}
        {showWarning && reachedMaxProducts && <MaxProductsReached />}
        {this.props.children}
      </div>
    )
  }
}

export default withBasket(LimitWrapper)
